<template>
  <div class="d-flex-column-center fs-5 lh-sm">
    <div
      :class="progressClass"
      class="align-self-end d-inline-flex items-center"
    >
      <span>{{ questionsProgress }}</span>
      <span class="px-1">/</span>
      <span>{{ availableProgress }}</span>
    </div>
    <small
      v-if="subTitle"
      class="d-block text-lowercase fs-6"
      style="letter-spacing: 0.098rem"
    >
      {{ subTitle }}
    </small>
  </div>
</template>

<script>
import entityProgress from '../mixins/entityProgress'
export default {
  mixins: [entityProgress],
  props: {
    progress: {
      type: [String, Number],
      default: null,
    },
    subTitle: {
      type: String,
      default: 'questions',
    },
    currentQuestionIds: {
      type: Array,
      required: true,
    },
  },
  computed: {
    progressClass() {
      return this.questionsProgress == this.availableProgress
        ? 'text-success text-600'
        : 'text-500'
    },
  },
}
</script>
